import cn from 'utils/cn';
import { IButtonVariant } from '../constants/Button.interface';

type Args = {
  variant: IButtonVariant;
};

const getButtonClass = ({
  variant,
  disabled,
  className = '',
}: Args & React.ButtonHTMLAttributes<HTMLButtonElement>): string => {
  return cn(
    `kobai-button button--${variant} tw:h-[40px] tw:px-4 tw:flex tw:items-center tw:font-normal tw:border-none tw:capitalize`,
    disabled ? 'tw:opacity-50' : 'tw:cursor-pointer',
    className
  );
};

export default getButtonClass;
